export default "__VITE_ASSET__BGj1i7fj__"